// @flow
import React from 'react';
import styled, { type StyledComponent } from 'styled-components';

import { PopoverEvent } from './popover.constants';

type StyledTargetWrapperProps = {
  event: PopoverEvent,
  display: 'inline' | 'inline-block' | 'block',
};

export const StyledTargetWrapper: StyledComponent<StyledTargetWrapperProps> = styled.div`
  width: 100%;
  display: ${props => props.display};
  cursor: ${props => (props.event === PopoverEvent.CLICK ? 'pointer' : 'default')};
`;

export type Props = {
  ...StyledTargetWrapperProps,
  innerRef: (?HTMLDivElement) => void,
};

const TargetWrapper = ({ innerRef, ...other }: Props) => (
  <StyledTargetWrapper {...other} ref={innerRef} />
);

export default TargetWrapper;



// WEBPACK FOOTER //
// ../react-lib/src/components/callouts/Popover/TargetWrapper.jsx